import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue-demi';
import { AbSlider, AbSliderItem } from '../../ui';
import FeatureSectionVideoTabsSlide from './FeatureSectionVideoTabsSlide.vue';
import { FeatureSectionVideoTabsSlideData } from '../../../types';

interface Props {
  slides: FeatureSectionVideoTabsSlideData[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FeatureSectionVideoTabsSlider',
  props: {
    slides: null
  },
  emits: ["slideChange", "playVideo", "init"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'slideChange', data: any): void;
  (e: 'playVideo', data?: string): void;
  (e: 'init', data: any): void;
}), expose: any, slots: any, attrs: any }) {




const swiper = ref();
const swiperOptions = {
  observer: true,
  lazy: true,
  navigation: true,
  on: {
    init: (swiper: any) => {
      emit('init', swiper);
    },
  },
};

const playVideo = (videoId?: string) => {
  emit('playVideo', videoId);
};

return { __sfc: true,emit, swiper, swiperOptions, playVideo, AbSlider, AbSliderItem, FeatureSectionVideoTabsSlide }
}

})